export default __webpack_public_path__ + "static/media/logo.9a6674e7.png";